<img src="../../../../../assets/images/events/2022/summerSchool/logo.png" alt="logo" class="center">
<div class="mt-3" align="center">
	PQCifris 2022 aims at bringing together students and researchers interested in
	post-quantum cryptography, introducing the topic, and offering the opportunity
	to present and discuss recent advances in the current research.
	<br>
	<br>
	The School is a two-and-a-half-day event, from Monday 10th to Wednesday 12th. It is
	mainly aimed at Ph.D. and M.Sc. students interested in the field of cryptography
	and it requires prior knowledge of commutative algebra, number theory, and
	cryptography at the graduate level.
	<br>
	<br>
	The second part of the event is a two-day Workshop, from Wednesday 12th afternoon
	to Friday 14th morning. It is aimed at both students and researchers, presenting
	and discussing state-of-the-art topics in post-quantum cryptography.
	<br>
	<br>
	For more details, see the website: <br>
	<a target="_blank" href="https://sites.google.com/unitn.it/pqcifris2022">https://sites.google.
		com/unitn.it/pqcifris2022</a>
</div>